var _path, _path2, _rect, _g, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiArrowCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60677 6.33301C2.59818 5.08655 2.9941 3.87093 3.7351 2.86861C4.47611 1.8663 5.52222 1.13135 6.71641 0.774101C7.9106 0.41685 9.18846 0.456564 10.3582 0.887282C11.5279 1.318 12.5263 2.11648 13.2037 3.16288",
    stroke: "black",
    strokeWidth: 0.639987,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1296 6.2539C14.1381 7.50036 13.7422 8.71598 13.0012 9.7183C12.2602 10.7206 11.2141 11.4556 10.0199 11.8128C8.82572 12.1701 7.54787 12.1303 6.37817 11.6996C5.20846 11.2689 4.21001 10.4704 3.53268 9.42403",
    stroke: "black",
    strokeWidth: 0.639987,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4939_35394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 5,
    width: 7,
    height: 3
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.37994,
    height: 6.17198,
    transform: "matrix(-1.19249e-08 1 1 1.19249e-08 -0.359375 5.36328)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4939_35394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.226563 4.5258L2.62313 6.92236L5.01969 4.5258",
    stroke: "black",
    strokeWidth: 0.586655
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4939_35394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 6,
    height: 4
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.47476,
    height: 5.48191,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 16.75 7.17773)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4939_35394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5098 8.01473L14.1132 5.61816L11.7166 8.01473",
    stroke: "black",
    strokeWidth: 0.586655
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiArrowCircle);
export default __webpack_public_path__ + "static/media/ai-arrow-circle.e898d52bd8308cc9e3c081a730fa89c1.svg";
export { ForwardRef as ReactComponent };